import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { useState } from 'react'
import { Analytics } from '@vercel/analytics/react'
import { SpeedInsights } from '@vercel/speed-insights/react'
import * as Sentry from '@sentry/react'
import NavBar from './components/NavBar'
import PageShell03 from './components/PageShell03'
import JobsGrid from './components/JobsGrid'
import Footer from './components/Footer'
import About from './components/About'
import News from './components/News'
import Helper from './components/Helper'
import Roadmap from './components/Roadmap'
import Companies from './components/Companies'
import CompanyPage from './components/CompanyPage'
import RemoteCompanies from './components/RemoteCompanies'
import DecimalsDesign from './components/DecimalsDesign'
import Featured from './components/Featured'
import Privacy from './pages/Privacy'
import Terms from './pages/Terms'
import { Toaster } from './components/ui/toaster'
import ContactFormButton from './components/contact/ContactFormButton'
import ContactFormModal from './components/contact/ContactFormModal'
import InfoBanner from './components/InfoBanner'
import type { LocationSuggestion } from './hooks/useLocationSearch'

function AppContent({ onFeedbackClick }: { onFeedbackClick: () => void }) {
  const [selectedLocation, setSelectedLocation] = useState<LocationSuggestion | null>(null)

  const handleLocationSelect = (location: LocationSuggestion | null) => {
    setSelectedLocation(location)
  }

  return (
    <>
      <NavBar onFeedbackClick={onFeedbackClick} />
      <PageShell03 />
      <JobsGrid
        selectedLocation={selectedLocation}
        onLocationSelect={handleLocationSelect}
        onFeedbackClick={onFeedbackClick}
      />
      <Footer />
    </>
  )
}

function App() {
  const [showFeedbackModal, setShowFeedbackModal] = useState(false)

  return (
    <Sentry.ErrorBoundary fallback={<div>An error has occurred</div>}>
      <InfoBanner />
      <BrowserRouter>
        <Routes>
        <Route path="/about" element={
          <>
            <NavBar onFeedbackClick={() => setShowFeedbackModal(true)} />
            <About />
            <Footer />
          </>
        } />
        <Route path="/roadmap" element={
          <>
            <NavBar onFeedbackClick={() => setShowFeedbackModal(true)} />
            <Roadmap />
            <Footer />
          </>
        } />
        <Route path="/news" element={
          <>
            <NavBar onFeedbackClick={() => setShowFeedbackModal(true)} />
            <News />
            <Footer />
          </>
        } />
        <Route path="/helper" element={
          <>
            <NavBar onFeedbackClick={() => setShowFeedbackModal(true)} />
            <Helper />
            <Footer />
          </>
        } />
        <Route path="/featured" element={
          <>
            <NavBar onFeedbackClick={() => setShowFeedbackModal(true)} />
            <Featured />
            <Footer />
          </>
        } />
        <Route path="/company/directory" element={
          <>
            <NavBar onFeedbackClick={() => setShowFeedbackModal(true)} />
            <Companies />
            <Footer />
          </>
        } />
        <Route path="/remote-companies" element={
          <>
            <NavBar onFeedbackClick={() => setShowFeedbackModal(true)} />
            <RemoteCompanies />
            <Footer />
          </>
        } />
        <Route path="/decimals-design" element={
          <>
            <NavBar onFeedbackClick={() => setShowFeedbackModal(true)} />
            <DecimalsDesign />
            <Footer />
          </>
        } />
        <Route path="/company/:companyName" element={
          <>
            <NavBar onFeedbackClick={() => setShowFeedbackModal(true)} />
            <CompanyPage />
            <Footer />
          </>
        } />
        <Route path="/privacy" element={
          <>
            <NavBar onFeedbackClick={() => setShowFeedbackModal(true)} />
            <Privacy />
            <Footer />
          </>
        } />
        <Route path="/terms" element={
          <>
            <NavBar onFeedbackClick={() => setShowFeedbackModal(true)} />
            <Terms />
            <Footer />
          </>
        } />
        <Route path="*" element={<AppContent onFeedbackClick={() => setShowFeedbackModal(true)} />} />
      </Routes>
      <Analytics />
      <SpeedInsights />
      <Toaster />

      {/* Contact Form Button (Global) */}
      {/* <ContactFormButton /> */}

      {/* Feedback Modal (Global) - Uses ContactFormModal */}
      {showFeedbackModal && (
        <ContactFormModal onClose={() => setShowFeedbackModal(false)} />
      )}
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  )
}

export default App
